import { GiftCardHistoryItemReceived } from "./gift-card-history-item-received";
import { GiftCardHistoryItemSent } from "./gift-card-history-item-sent";
import type { GiftCardHistoryItem as GiftCardHistoryItemType } from "./types";

interface GiftCardHistoryItemProps {
  item: GiftCardHistoryItemType;
}

export const GiftCardHistoryItem = ({ item }: GiftCardHistoryItemProps) => {
  if (item.isSent) {
    return <GiftCardHistoryItemSent item={item} />;
  }
  return <GiftCardHistoryItemReceived item={item} />;
};
